$('[data-scrollto]').on('click', function(e) {
    e.preventDefault();
    var target = $(this).attr('href');

    if($('.site-nav').is('.show'))
        $('.site-nav').removeClass('show');

    $('html, body').animate({
        scrollTop: $(target).offset().top - $('.site-nav').outerHeight()
    }, 1000);

});

$(window).on('scroll', function() {
    var scrollTop = $(window).scrollTop();

    $('[data-scrollto]').removeClass('current');
    $('[data-scrollto]').first().addClass('current');

    $('[data-scrollto]').each(function(i) {
        var target = $(this).attr('href');

        if ( scrollTop >= ($(target).offset().top  - $('.site-nav').outerHeight() - 5) ) { 
            $('[data-scrollto]').removeClass('current');
            $(this).addClass('current');
        }
    });

        
    
});